var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOurTeam(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 459.328,
    height: 414.747,
    viewBox: "0 0 459.328 414.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Our_Team",
    "data-name": "Our Team",
    transform: "translate(-1261.398 -1727.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M173.2,35.4c61.648-67.388,107.14-67.527,124.156.944s-38.448,201.862-74.5,258.439-84.711,77.556-120.878,69.21-72.045-45.226-56.954-90.232,36.613-51.07,70.148-93.075S111.552,102.788,173.2,35.4Z",
    transform: "translate(1557.409 1698.956) rotate(60)",
    fill: "#ffdc9c"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Our_Team-2",
    "data-name": "Our Team",
    transform: "translate(1491.062 1993.961)",
    fill: "#fff",
    fontSize: 55,
    fontFamily: "SecondaRound-Black, Seconda Round",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -121,
    y: 0
  }, "Our Team")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_534_",
    transform: "translate(919.844 1743.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_42500_",
    transform: "translate(517.53 121.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_161_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_173_",
    d: "M517.9,133.6v26.8l12.519,7.226v-26.8Z",
    transform: "translate(-517.114 -107.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_172_",
    d: "M574.424,158.724v26.8L530.3,160.041v-26.8Z",
    transform: "translate(-503.158 -108.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_169_",
    d: "M603.7,162.6l-15.3,8.842-44.145-25.484-13.836,7.992L517.9,146.722l42.933-24.782,12.519,7.226-13.794,7.97Z",
    transform: "translate(-517.114 -121.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_167_",
    d: "M603.7,164.409l-15.3,8.842-44.145-25.484-13.836,7.992L517.9,148.532l42.933-24.782,12.519,7.226-13.794,7.97Z",
    transform: "translate(-517.114 -118.968)",
    fill: "#ffdc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_162_",
    d: "M604.906,163.541h0v-.914l-.786-.446h0l-29.564-17.067V130.087h0v-.914l-.786-.446h0L561.25,121.5l-42.933,24.782h0l-.786.446v.914h0v26.8l12.519,7.226h0l.786.446.786-.446h0l13.05-7.524,43.359,25.037h0l.786.446.786-.446h0l15.3-8.842v-26.8ZM561.25,123.328,572.2,129.64l-13.794,7.97,1.042.6,15.112,8.714h0l27.992,16.153L588.816,171l-43.359-25.037h0l-.786-.446-.786.446h0l-6.121,3.549-6.908,4L519.91,147.2ZM519.1,173.551V148.557l10.946,6.312v24.995Zm26.334-.765V147.791l42.572,24.57v24.995Z",
    transform: "translate(-517.53 -121.5)",
    fill: "#0c1859"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3024_",
    transform: "translate(521.648 128.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3023_",
    d: "M552.51,144.245c.574.34.574.871,0,1.19a2.211,2.211,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.211,2.211,0,0,1,552.51,144.245Z",
    transform: "translate(-485.086 -103.373)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3022_",
    d: "M555.06,142.775c.574.34.574.871,0,1.19a2.211,2.211,0,0,1-2.062,0,.627.627,0,0,1,0-1.19A2.21,2.21,0,0,1,555.06,142.775Z",
    transform: "translate(-482.216 -105.028)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3020_",
    d: "M557.6,141.3c.574.34.574.871,0,1.19a2.21,2.21,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.341,2.341,0,0,1,557.6,141.3Z",
    transform: "translate(-479.358 -106.674)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3019_",
    d: "M549.969,142.775c.574.34.574.871,0,1.19a2.21,2.21,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.21,2.21,0,0,1,549.969,142.775Z",
    transform: "translate(-487.945 -105.028)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3018_",
    d: "M552.51,141.3c.574.34.574.871,0,1.19a2.211,2.211,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.342,2.342,0,0,1,552.51,141.3Z",
    transform: "translate(-485.086 -106.674)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3016_",
    d: "M555.06,139.827a.627.627,0,0,1,0,1.19,2.211,2.211,0,0,1-2.062,0,.627.627,0,0,1,0-1.19A2.342,2.342,0,0,1,555.06,139.827Z",
    transform: "translate(-482.216 -108.328)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3015_",
    d: "M547.419,141.3c.574.34.574.871,0,1.19a2.21,2.21,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.341,2.341,0,0,1,547.419,141.3Z",
    transform: "translate(-490.814 -106.674)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3014_",
    d: "M549.969,139.827a.627.627,0,0,1,0,1.19,2.21,2.21,0,0,1-2.062,0,.627.627,0,0,1,0-1.19A2.341,2.341,0,0,1,549.969,139.827Z",
    transform: "translate(-487.945 -108.328)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3013_",
    d: "M552.51,138.357c.574.34.574.871,0,1.19a2.342,2.342,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.342,2.342,0,0,1,552.51,138.357Z",
    transform: "translate(-485.086 -109.982)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_3012_",
    cx: 1.467,
    cy: 0.85,
    rx: 1.467,
    ry: 0.85,
    transform: "translate(48.699 31.244)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3011_",
    d: "M547.419,138.357c.574.34.574.871,0,1.19a2.341,2.341,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.341,2.341,0,0,1,547.419,138.357Z",
    transform: "translate(-490.814 -109.982)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3010_",
    d: "M549.969,136.887a.627.627,0,0,1,0,1.19,2.21,2.21,0,0,1-2.062,0,.627.627,0,0,1,0-1.19A2.341,2.341,0,0,1,549.969,136.887Z",
    transform: "translate(-487.945 -111.637)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3009_",
    d: "M542.339,138.357c.574.34.574.871,0,1.19a2.341,2.341,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.341,2.341,0,0,1,542.339,138.357Z",
    transform: "translate(-496.531 -109.982)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3004_",
    d: "M544.88,136.887a.627.627,0,0,1,0,1.19,2.211,2.211,0,0,1-2.062,0,.627.627,0,0,1,0-1.19A2.342,2.342,0,0,1,544.88,136.887Z",
    transform: "translate(-493.673 -111.637)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2993_",
    d: "M547.419,135.435c.574.34.574.871,0,1.19a2.21,2.21,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.21,2.21,0,0,1,547.419,135.435Z",
    transform: "translate(-490.814 -113.288)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2992_",
    cx: 1.467,
    cy: 0.85,
    rx: 1.467,
    ry: 0.85,
    transform: "translate(37.88 25.016)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2991_",
    d: "M542.339,135.435c.574.34.574.871,0,1.19a2.21,2.21,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.21,2.21,0,0,1,542.339,135.435Z",
    transform: "translate(-496.531 -113.288)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2989_",
    cx: 1.467,
    cy: 0.85,
    rx: 1.467,
    ry: 0.85,
    transform: "translate(48.699 18.767)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2988_",
    d: "M537.22,135.407c.574.34.574.871,0,1.19a2.211,2.211,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.341,2.341,0,0,1,537.22,135.407Z",
    transform: "translate(-502.294 -113.302)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2987_",
    cx: 1.467,
    cy: 0.85,
    rx: 1.467,
    ry: 0.85,
    transform: "translate(37.838 18.725)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2985_",
    d: "M542.309,132.467c.574.34.574.871,0,1.19a2.21,2.21,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.341,2.341,0,0,1,542.309,132.467Z",
    transform: "translate(-496.565 -116.611)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2984_",
    d: "M534.679,133.937a.627.627,0,0,1,0,1.19,2.21,2.21,0,0,1-2.062,0,.627.627,0,0,1,0-1.19A2.341,2.341,0,0,1,534.679,133.937Z",
    transform: "translate(-505.152 -114.957)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2983_",
    cx: 1.467,
    cy: 0.85,
    rx: 1.467,
    ry: 0.85,
    transform: "translate(32.439 15.601)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2982_",
    d: "M539.77,131c.574.34.574.871,0,1.19a2.211,2.211,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.341,2.341,0,0,1,539.77,131Z",
    transform: "translate(-499.424 -118.265)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2981_",
    d: "M524.5,136.885c.574.34.574.871,0,1.19a2.341,2.341,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.21,2.21,0,0,1,524.5,136.885Z",
    transform: "translate(-516.609 -111.656)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2980_",
    d: "M527.049,135.407c.574.34.574.871,0,1.19a2.21,2.21,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.341,2.341,0,0,1,527.049,135.407Z",
    transform: "translate(-513.739 -113.302)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2979_",
    d: "M529.59,133.937a.627.627,0,0,1,0,1.19,2.211,2.211,0,0,1-2.062,0,.627.627,0,0,1,0-1.19A2.342,2.342,0,0,1,529.59,133.937Z",
    transform: "translate(-510.881 -114.957)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2978_",
    cx: 1.467,
    cy: 0.85,
    rx: 1.467,
    ry: 0.85,
    transform: "translate(21.621 15.601)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2977_",
    cx: 1.467,
    cy: 0.85,
    rx: 1.467,
    ry: 0.85,
    transform: "translate(27.019 12.497)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2976_",
    d: "M537.22,129.545c.574.34.574.871,0,1.19a2.211,2.211,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.21,2.21,0,0,1,537.22,129.545Z",
    transform: "translate(-502.294 -119.917)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2963_",
    d: "M539.77,128.075c.574.34.574.871,0,1.19a2.211,2.211,0,0,1-2.062,0,.627.627,0,0,1,0-1.19A2.211,2.211,0,0,1,539.77,128.075Z",
    transform: "translate(-499.424 -121.571)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2962_",
    d: "M542.309,126.605c.574.34.574.871,0,1.19a2.341,2.341,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19a2.21,2.21,0,0,1,2.062,0Z",
    transform: "translate(-496.565 -123.226)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2961_",
    d: "M521.96,135.407c.574.34.574.871,0,1.19a2.211,2.211,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.341,2.341,0,0,1,521.96,135.407Z",
    transform: "translate(-519.468 -113.302)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2960_",
    d: "M524.5,133.937c.574.34.574.871,0,1.19a2.21,2.21,0,0,1-2.062,0,.627.627,0,0,1,0-1.19A2.341,2.341,0,0,1,524.5,133.937Z",
    transform: "translate(-516.609 -114.957)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2959_",
    d: "M527.049,132.467c.574.34.574.871,0,1.19a2.21,2.21,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.341,2.341,0,0,1,527.049,132.467Z",
    transform: "translate(-513.739 -116.611)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2958_",
    d: "M529.59,131a.627.627,0,0,1,0,1.19,2.211,2.211,0,0,1-2.062,0,.627.627,0,0,1,0-1.19A2.342,2.342,0,0,1,529.59,131Z",
    transform: "translate(-510.881 -118.265)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2957_",
    cx: 1.467,
    cy: 0.85,
    rx: 1.467,
    ry: 0.85,
    transform: "translate(21.621 9.373)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_2956_",
    cx: 1.467,
    cy: 0.85,
    rx: 1.467,
    ry: 0.85,
    transform: "translate(27.019 6.249)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2955_",
    d: "M537.22,126.605c.574.34.574.871,0,1.19a2.342,2.342,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19A2.211,2.211,0,0,1,537.22,126.605Z",
    transform: "translate(-502.294 -123.226)",
    fill: "#0c1859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2953_",
    d: "M539.77,125.135c.574.34.574.871,0,1.19a2.211,2.211,0,0,1-2.062,0c-.574-.34-.574-.871,0-1.19a2.211,2.211,0,0,1,2.062,0Z",
    transform: "translate(-499.424 -124.88)",
    fill: "#0c1859"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurTeam);
export default __webpack_public_path__ + "static/media/ourTeam.01cff28bb22d11746e2570aef6ad2b70.svg";
export { ForwardRef as ReactComponent };